import gql from 'graphql-tag';

import recentlyEditedMainDisplayObjectFragment from './recentlyEditedMainDisplayObjectFragment';

export const recentlyEditedMainDisplayObjectsGroupedByIntegrationItemKindFragment = gql`
  fragment recentlyEditedMainDisplayObjectsGroupedByIntegrationItemKindFragment on RecentlyEditedMainDisplayObjectsGroupedByIntegrationItemKind {
    dokkioClass
    integrationItemKind
    recentlyEditedMainDisplayObjects {
      ...recentlyEditedMainDisplayObjectFragment
    }
  }
  ${recentlyEditedMainDisplayObjectFragment}
`;
export default recentlyEditedMainDisplayObjectsGroupedByIntegrationItemKindFragment;
